<template>
  <div>
    <div class="mdn-Spinner">
      <v-progress-circular
      indeterminate
      color="white"
    ></v-progress-circular>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SGPLoadingComponent'
}
</script>